import WCardForm from '../../components/WCardForm/WCardForm'
import WCardFormMixin from './w-card-form-mixin'
import WFormDataMixin from './w-data-mixin'

export default {
    mixins: [
        WCardFormMixin,
        WFormDataMixin
    ],
    components: {
        WCardForm
    },
    computed: {
        defaultFormEvents () {
            const vm = this
            return {
                ...vm.wCardFormEvents,
                [vm.primaryButtonEvent]: vm.handleSubmit,
                [vm.secondaryButtonEvent]: vm.handleClose,
                [vm.closeButtonEvent]: vm.handleClose,
                'form-data:change': vm.handleFormDataChange,
                'reset:errors': vm.resetFormErrors
            }
        },
        formEvents () {
            const vm = this
            return vm.defaultFormEvents
        },
        defaultFormProps () {
            const vm = this
            return {
                ...vm.wCardFormProps,
                readonly: vm.loading || vm.readonly,
                primaryButtonDisabled: vm.primaryButtonDisabled || !vm.canSubmit
            }
        },
        formProps () {
            const vm = this
            return vm.defaultFormProps
        }
    },
    methods: {
        handleClose () {
            const vm = this
            vm.$emit('close', vm.hasFormDataChanged)
        }
    }
}
